import RosService from "@/services/RosService.js";

const state = {
  all: [],
  farm: {},
};

const mutations = {
  ADD_FARM(state, farm) {
    state.all.push(farm);
  },
  SET_FARMS(state, farms) {
    state.all = farms;
  },
  SET_FARM(state, farm) {
    state.farm = farm;
  },
  UPDATE_FARM(state, farm) {
    let index = state.all.indexOf(farm);
    state.all[index] = farm;
  },
  DELETE_FARM(state, farmId) {
    let farm = state.all.find((farm) => farm.id === farmId);
    state.all.splice(state.all.indexOf(farm), 1);
  },
};

const actions = {
  createFarm({ commit }, farm) {
    let ids = state.all.map((n) => n.id);
    let id = null;
    if (ids.length == 0) {
      id = 1;
    } else {
      id = Math.max(...ids) + 1;
    }
    farm.id = id;
    state.all.push(farm);
    RosService.updateFarms(state.all);
  },
  setFarms({ commit }, farms) {
    commit("SET_FARMS", farms);
  },
  updateFarm({ commit }, farm) {
    // return FarmService.postEvent(farm).then(() => {
    commit("UPDATE_FARM", farm);
    RosService.updateFarms(state.all);
    // })
  },
  deleteFarm({ commit }, farm) {
    commit("DELETE_FARM", farm);
    RosService.updateFarms(state.all);
  },
};

const getters = {
  getFarmById: (state) => (id) => {
    return state.all.find((farm) => farm.id === id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
